import { createContext } from 'react';

export type NotifyArgs = string | { text: string; title?: string; action?: React.ReactNode };

export type LtNotificationsContextProps = {
  notifyInfo: (args: NotifyArgs) => void;
  notifySuccess: (args: NotifyArgs, toDismissId?: string) => void;
  notifyError: (args: NotifyArgs, toDismissId?: string) => void;
  notifyLoading: (id: string) => void;
  dismiss: (id: string) => void;
  dismissAll: () => void;
  notify: {
    success: (
      text: string,
      options?: {
        id: string;
      },
    ) => void;
    error: (
      text: string,
      options?: {
        id: string;
      },
    ) => void;
    loading: (
      text: string,
      options?: {
        id: string;
      },
    ) => void;
    dismiss: (id: string) => void;
  };
};

export const LtNotificationsContext = createContext<LtNotificationsContextProps>({
  notifyInfo: () => {},
  notifySuccess: () => {},
  notifyError: () => {},
  notifyLoading: () => {},
  dismiss: () => {},
  dismissAll: () => {},
  notify: {
    success: () => {},
    error: () => {},
    loading: () => {},
    dismiss: () => {},
  },
});
